import clickOk from '../sounds/click_ok.mp3';

// NUMBERS
import numbersPracticeInstructionStart
    from '../sounds/ran_numbers_practice_instruction_start.mp3';
import numbersItemOne from '../sounds/ran_numbers_seven.mp3';
import numbersItemTwo from '../sounds/ran_numbers_nine.mp3';
import numbersItemThree from '../sounds/ran_numbers_four.mp3';
import numbersItemFour from '../sounds/ran_numbers_one.mp3';
import numbersItemFive from '../sounds/ran_numbers_six.mp3';
import numbersPracticeInstructionGeneral
    from '../sounds/ran_numbers_practice_instruction_general.mp3';
import numbersPracticeReadyInstruction
    from '../sounds/ran_numbers_practice_ready_instruction.mp3';

// Alyx English Audios
import numbersPracticeInstructionStartAlyx
    from '../sounds/alyx/english/ran_numbers_practice_instruction_start_alyx.mp3';
import numbersItemOneAlyx from '../sounds/alyx/english/ran_numbers_seven_alyx.mp3';
import numbersItemTwoAlyx from '../sounds/alyx/english/ran_numbers_nine_alyx.mp3';
import numbersItemThreeAlyx from '../sounds/alyx/english/ran_numbers_four_alyx.mp3';
import numbersItemFourAlyx from '../sounds/alyx/english/ran_numbers_one_alyx.mp3';
import numbersItemFiveAlyx from '../sounds/alyx/english/ran_numbers_six_alyx.mp3';
import numbersPracticeInstructionGeneralAlyx
    from '../sounds/alyx/english/ran_numbers_practice_instruction_general_alyx_alyx.mp3';
import numbersPracticeReadyInstructionAlyx
    from '../sounds/alyx/english/ran_numbers_practice_ready_instruction_alyx.mp3';
import clickOkAlyx from '../sounds/alyx/english/click_ok_alyx.mp3';
import { selectAvatarAudio } from '../common/alex/AlexUtils';

const owlAudioInstructions = [
    numbersItemOne,
    numbersItemTwo,
    numbersItemThree,
    numbersItemFour,
    numbersItemFive,
];

const alyxAudioInstructions = [
    numbersItemOneAlyx,
    numbersItemTwoAlyx,
    numbersItemThreeAlyx,
    numbersItemFourAlyx,
    numbersItemFiveAlyx,
];

const RAN_AUDIO_INSTRUCTIONS = {
    numbers: {
        practiceInstructionStart: selectAvatarAudio(numbersPracticeInstructionStart, numbersPracticeInstructionStartAlyx),
        autoplayInstructions: selectAvatarAudio(owlAudioInstructions, alyxAudioInstructions),
        practiceInstructionGeneral: selectAvatarAudio(numbersPracticeInstructionGeneral, numbersPracticeInstructionGeneralAlyx),
        practiceReadyInstruction: selectAvatarAudio(numbersPracticeReadyInstruction, numbersPracticeReadyInstructionAlyx),
    },
    clickOk: selectAvatarAudio(clickOk, clickOkAlyx),
};

export const RAN_ACTIVITY_TIMER = 'RANActivityTimer';

export default RAN_AUDIO_INSTRUCTIONS;
